// bill_subsystem_v1 + customer_stats_v1 + customer_crud_v1: customers CRUD
// customer_telegrams_v1: ลูกค้า 1 ราย ผูก Telegram ได้หลายไอดี (chat_id + label)
import React, { useState, useEffect } from 'react';
import API from '../api';

function fmtDate(d) {
  if (!d) return '-';
  try { return new Date(d).toLocaleDateString('th-TH', { year: 'numeric', month: 'short', day: 'numeric' }); }
  catch (e) { return d; }
}

function fmtMoney(n) {
  return Number(n || 0).toLocaleString('th-TH', { minimumFractionDigits: 0 });
}

/* customer_telegrams_v1: form ใช้ telegrams array แทน telegram_chat_id เดี่ยว */
const EMPTY_FORM = { name: '', phone: '', email: '', address: '', telegrams: [], line_user_id: '', note: '' };

export default function BillCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  /* bill_line_picker_v1: เลือก LINE contact จากระบบแชท */
  const [linePickerOpen, setLinePickerOpen] = useState(false);
  const [lineContacts, setLineContacts] = useState([]);
  const [lineLoading, setLineLoading] = useState(false);
  const [lineSearch, setLineSearch] = useState('');

  function openLinePicker() {
    setLinePickerOpen(!linePickerOpen);
    if (!linePickerOpen && lineContacts.length === 0) {
      setLineLoading(true);
      API.get('/api/customers/line-contacts')
        .then(function (r) { setLineContacts(Array.isArray(r.data) ? r.data : []); })
        .catch(function () { setLineContacts([]); })
        .finally(function () { setLineLoading(false); });
    }
  }
  function pickLineContact(ct) {
    var patch = { line_user_id: ct.line_user_id };
    if (!form.name || !form.name.trim()) patch.name = ct.name || '';
    setForm(Object.assign({}, form, patch));
    setLinePickerOpen(false);
  }

  function load() {
    setLoading(true);
    API.get('/api/customers')
      .then(function (r) { setCustomers(r.data || []); })
      .catch(function () {})
      .finally(function () { setLoading(false); });
  }

  useEffect(function () { load(); }, []);

  function resetForm() {
    setForm(EMPTY_FORM);
    setEditing(null);
    setShowForm(false);
    setError('');
  }

  function openCreate() {
    resetForm();
    setShowForm(true);
  }

  function openEdit(c) {
    setEditing(c);
    /* customer_telegrams_v1: map telegrams array จาก backend (fallback column เดิมถ้า array ว่าง) */
    var tgs = [];
    if (Array.isArray(c.telegrams) && c.telegrams.length) {
      tgs = c.telegrams.map(function (t) { return { chat_id: t.chat_id || '', label: t.label || '' }; });
    } else if (c.telegram_chat_id) {
      tgs = [{ chat_id: c.telegram_chat_id, label: '' }];
    }
    setForm({
      name: c.name || '',
      phone: c.phone || '',
      email: c.email || '',
      address: c.address || '',
      telegrams: tgs,
      line_user_id: c.line_user_id || '',
      note: c.note || '',
    });
    setShowForm(true);
    setError('');
  }

  /* customer_telegrams_v1: helper จัดการแถว telegram */
  function addTelegram() {
    setForm(Object.assign({}, form, { telegrams: form.telegrams.concat([{ chat_id: '', label: '' }]) }));
  }
  function updateTelegram(idx, field, value) {
    var next = form.telegrams.map(function (t, i) {
      if (i !== idx) return t;
      var n = Object.assign({}, t);
      n[field] = value;
      return n;
    });
    setForm(Object.assign({}, form, { telegrams: next }));
  }
  function removeTelegram(idx) {
    setForm(Object.assign({}, form, { telegrams: form.telegrams.filter(function (t, i) { return i !== idx; }) }));
  }

  async function handleSave() {
    setError('');
    if (!form.name.trim()) { setError('กรอกชื่อลูกค้า'); return; }

    /* customer_telegrams_v1: กรอง chat_id ว่างออก + trim */
    var tgClean = form.telegrams
      .map(function (t) { return { chat_id: (t.chat_id || '').trim(), label: (t.label || '').trim() || null }; })
      .filter(function (t) { return t.chat_id.length > 0; });

    setSaving(true);
    var payload = {
      name: form.name.trim(),
      phone: form.phone.trim() || null,
      email: form.email.trim() || null,
      address: form.address.trim() || null,
      telegrams: tgClean,
      telegram_chat_id: tgClean.length ? tgClean[0].chat_id : null, /* sync column เดิม = ไอดีแรก */
      line_user_id: form.line_user_id.trim() || null,
      note: form.note.trim() || null,
    };

    try {
      if (editing) {
        await API.put('/api/customers/' + editing.id, payload);
      } else {
        await API.post('/api/customers', payload);
      }
      resetForm();
      load();
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.error) || 'บันทึกไม่สำเร็จ');
    } finally {
      setSaving(false);
    }
  }

  async function handleDelete(c) {
    if (!window.confirm('ลบ ' + c.name + '?')) return;
    try {
      await API.delete('/api/customers/' + c.id);
      load();
    } catch (err) {
      alert((err.response && err.response.data && err.response.data.error) || 'ลบไม่สำเร็จ');
    }
  }

  var filtered = customers;
  if (search.trim()) {
    var q = search.trim().toLowerCase();
    filtered = customers.filter(function (c) {
      return ((c.name || '').toLowerCase().indexOf(q) >= 0) ||
             ((c.phone || '').toLowerCase().indexOf(q) >= 0) ||
             ((c.email || '').toLowerCase().indexOf(q) >= 0);
    });
  }

  var totalRevenue = customers.reduce(function (s, c) { return s + Number(c.total_amount || 0); }, 0);
  var totalInvoices = customers.reduce(function (s, c) { return s + Number(c.invoice_count || 0); }, 0);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, gap: 12, flexWrap: 'wrap' }}>
        <h1 style={{ margin: 0, fontSize: 22 }}>ลูกค้า</h1>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <input value={search} onChange={function (e) { setSearch(e.target.value); }} placeholder="ค้นหา..." style={{ width: 180, padding: '8px 12px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, fontFamily: 'inherit' }} />
          <button onClick={openCreate} style={{ background: '#10b981', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>+ เพิ่ม</button>
        </div>
      </div>

      {!loading && customers.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 12, marginBottom: 20 }}>
          <div style={{ background: 'white', borderRadius: 10, padding: 14, border: '1px solid #e2e8f0' }}>
            <div style={{ fontSize: 11, color: '#64748b' }}>ลูกค้าทั้งหมด</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#0f172a' }}>{customers.length}</div>
          </div>
          <div style={{ background: 'white', borderRadius: 10, padding: 14, border: '1px solid #e2e8f0' }}>
            <div style={{ fontSize: 11, color: '#64748b' }}>บิลรวม</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#0ea5e9' }}>{totalInvoices}</div>
          </div>
          <div style={{ background: 'white', borderRadius: 10, padding: 14, border: '1px solid #e2e8f0' }}>
            <div style={{ fontSize: 11, color: '#64748b' }}>ยอดสะสมรวม</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#10b981' }}>฿{fmtMoney(totalRevenue)}</div>
          </div>
        </div>
      )}

      {loading ? (
        <div style={{ color: '#94a3b8' }}>กำลังโหลด...</div>
      ) : filtered.length === 0 ? (
        <div style={{ background: 'white', padding: 40, borderRadius: 12, textAlign: 'center', color: '#94a3b8', border: '1px solid #e2e8f0' }}>{customers.length === 0 ? 'ยังไม่มีลูกค้า — กด "+ เพิ่ม"' : 'ไม่พบลูกค้าที่ค้นหา'}</div>
      ) : (
        <div style={{ background: 'white', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr style={{ background: '#f8fafc', textAlign: 'left' }}>
                <th style={{ padding: 12 }}>ชื่อลูกค้า</th>
                <th style={{ padding: 12 }}>เบอร์ / Email</th>
                <th style={{ padding: 12, textAlign: 'center' }}>ช่อง</th>
                <th style={{ padding: 12, textAlign: 'right' }}>บิล</th>
                <th style={{ padding: 12, textAlign: 'right' }}>ยอดรวม</th>
                <th style={{ padding: 12 }}>บิลล่าสุด</th>
                <th style={{ padding: 12, textAlign: 'right' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(function (c) {
                /* customer_telegrams_v1: นับจำนวนไอดีจาก array (fallback column เดิม) */
                var tgCount = (Array.isArray(c.telegrams) && c.telegrams.length)
                  ? c.telegrams.length
                  : ((c.telegram_chat_id && String(c.telegram_chat_id).length > 0) ? 1 : 0);
                var hasLine = c.line_user_id && String(c.line_user_id).length > 0;
                return (
                  <tr key={c.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                    <td style={{ padding: 12, fontWeight: 500 }}>{c.name}</td>
                    <td style={{ padding: 12, fontSize: 13, color: '#475569' }}>
                      <div>{c.phone || '-'}</div>
                      {c.email ? <div style={{ fontSize: 11, color: '#94a3b8' }}>{c.email}</div> : null}
                    </td>
                    <td style={{ padding: 12, textAlign: 'center', fontSize: 11 }}>
                      {tgCount > 0 ? <span title={'Telegram ' + tgCount + ' ไอดี'} style={{ marginRight: 4 }}>📱{tgCount > 1 ? '×' + tgCount : ''}</span> : null}
                      {hasLine ? <span title="LINE">💬</span> : null}
                      {tgCount === 0 && !hasLine ? <span style={{ color: '#94a3b8' }}>-</span> : null}
                    </td>
                    <td style={{ padding: 12, textAlign: 'right', fontWeight: 500 }}>{c.invoice_count || 0}</td>
                    <td style={{ padding: 12, textAlign: 'right', fontWeight: 500, color: Number(c.total_amount||0) > 0 ? '#10b981' : '#94a3b8' }}>฿{fmtMoney(c.total_amount)}</td>
                    <td style={{ padding: 12, color: '#64748b', fontSize: 12 }}>{fmtDate(c.last_invoice_at)}</td>
                    <td style={{ padding: 12, textAlign: 'right', whiteSpace: 'nowrap' }}>
                      <button onClick={function () { openEdit(c); }} style={{ background: 'none', border: '1px solid #e2e8f0', padding: '4px 10px', borderRadius: 6, fontSize: 12, marginRight: 4, cursor: 'pointer' }}>แก้ไข</button>
                      <button onClick={function () { handleDelete(c); }} style={{ background: 'none', border: '1px solid #fecaca', color: '#dc2626', padding: '4px 10px', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>ลบ</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {showForm && (
        <div onClick={function () { if (!saving) resetForm(); }} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, zIndex: 100 }}>
          <div onClick={function (e) { e.stopPropagation(); }} style={{ background: 'white', borderRadius: 14, padding: 24, maxWidth: 540, width: '100%', maxHeight: '90vh', overflowY: 'auto' }}>
            <h3 style={{ margin: '0 0 16px' }}>{editing ? 'แก้ไขลูกค้า' : 'เพิ่มลูกค้า'}</h3>

            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 13, color: '#475569' }}>ชื่อลูกค้า <span style={{ color: '#dc2626' }}>*</span></label>
              <input value={form.name} onChange={function (e) { setForm(Object.assign({}, form, { name: e.target.value })); }} autoFocus style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, boxSizing: 'border-box' }} />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ fontSize: 13, color: '#475569' }}>เบอร์โทร</label>
                <input value={form.phone} onChange={function (e) { setForm(Object.assign({}, form, { phone: e.target.value })); }} style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: 13, color: '#475569' }}>Email</label>
                <input type="email" value={form.email} onChange={function (e) { setForm(Object.assign({}, form, { email: e.target.value })); }} style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, boxSizing: 'border-box' }} />
              </div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 13, color: '#475569' }}>ที่อยู่</label>
              <textarea value={form.address} onChange={function (e) { setForm(Object.assign({}, form, { address: e.target.value })); }} rows={2} style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, boxSizing: 'border-box', fontFamily: 'inherit', resize: 'vertical' }} />
            </div>

            <div style={{ background: '#f8fafc', padding: 12, borderRadius: 10, marginBottom: 12 }}>
              <div style={{ fontSize: 13, color: '#475569', marginBottom: 8, fontWeight: 600 }}>📲 ช่องทางส่งบิล</div>

              {/* customer_telegrams_v1: list หลาย Telegram ID (chat_id + label) */}
              <div style={{ marginBottom: 10 }}>
                <label style={{ fontSize: 12, color: '#64748b' }}>Telegram Chat ID (ใส่ได้หลายไอดี — ส่งบิลทุกอัน)</label>
                {form.telegrams.length === 0 ? (
                  <div style={{ fontSize: 12, color: '#94a3b8', padding: '6px 0' }}>ยังไม่มี — กด "+ เพิ่ม Telegram ID"</div>
                ) : (
                  form.telegrams.map(function (t, idx) {
                    return (
                      <div key={idx} style={{ display: 'flex', gap: 6, marginTop: 6, alignItems: 'center' }}>
                        <input value={t.chat_id} onChange={function (e) { updateTelegram(idx, 'chat_id', e.target.value); }} placeholder="-100..." style={{ flex: 2, padding: 8, borderRadius: 6, border: '1px solid #e2e8f0', fontSize: 13, boxSizing: 'border-box' }} />
                        <input value={t.label} onChange={function (e) { updateTelegram(idx, 'label', e.target.value); }} placeholder="ชื่อกำกับ (เช่น มือถือ)" style={{ flex: 2, padding: 8, borderRadius: 6, border: '1px solid #e2e8f0', fontSize: 13, boxSizing: 'border-box' }} />
                        <button onClick={function () { removeTelegram(idx); }} title="ลบไอดีนี้" style={{ flex: '0 0 auto', width: 32, height: 32, borderRadius: 6, border: '1px solid #fecaca', background: 'white', color: '#dc2626', cursor: 'pointer', fontSize: 16, lineHeight: 1 }}>×</button>
                      </div>
                    );
                  })
                )}
                <button onClick={addTelegram} style={{ marginTop: 8, padding: '6px 12px', borderRadius: 6, border: '1px dashed #10b981', background: 'white', color: '#10b981', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>+ เพิ่ม Telegram ID</button>
              </div>

              <div>
                <label style={{ fontSize: 12, color: '#64748b' }}>LINE User ID</label>
                <input value={form.line_user_id} onChange={function (e) { setForm(Object.assign({}, form, { line_user_id: e.target.value })); }} placeholder="U..." style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #e2e8f0', fontSize: 13, marginTop: 4, boxSizing: 'border-box' }} />
                {/* bill_line_picker_v1: เลือกจากแชท */}
                <button type="button" onClick={openLinePicker} style={{ marginTop: 6, padding: '6px 12px', borderRadius: 6, border: '1px dashed #06c755', background: 'white', color: '#06c755', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>📋 เลือกจากแชท</button>
                {linePickerOpen && (
                  <div style={{ marginTop: 6, border: '1px solid #e2e8f0', borderRadius: 8, background: '#f8fafc', padding: 8, maxHeight: 220, overflowY: 'auto' }}>
                    <input value={lineSearch} onChange={function (e) { setLineSearch(e.target.value); }} placeholder="ค้นชื่อ..." style={{ width: '100%', padding: 6, borderRadius: 6, border: '1px solid #e2e8f0', fontSize: 13, boxSizing: 'border-box', marginBottom: 6 }} />
                    {lineLoading ? (
                      <div style={{ fontSize: 12, color: '#94a3b8', padding: 6 }}>กำลังโหลด...</div>
                    ) : lineContacts.length === 0 ? (
                      <div style={{ fontSize: 12, color: '#94a3b8', padding: 6 }}>ไม่พบ LINE contact — ให้ลูกค้าแอด LINE OA ของร้านแล้วทักเข้ามาก่อน</div>
                    ) : (
                      lineContacts.filter(function (ct) { return !lineSearch.trim() || String(ct.name || '').toLowerCase().indexOf(lineSearch.trim().toLowerCase()) >= 0; }).map(function (ct) {
                        return (
                          <div key={ct.line_user_id} onClick={function () { pickLineContact(ct); }} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', borderRadius: 6, cursor: 'pointer', background: form.line_user_id === ct.line_user_id ? '#dcfce7' : 'transparent' }}>
                            {ct.profile_pic ? <img src={ct.profile_pic} alt="" style={{ width: 28, height: 28, borderRadius: '50%' }} /> : <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#06c755', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12 }}>{String(ct.name || '?').slice(0, 1)}</div>}
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{ fontSize: 13, fontWeight: 600, color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{ct.name || '(ไม่มีชื่อ)'}</div>
                              <div style={{ fontSize: 11, color: '#94a3b8', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{ct.line_user_id}</div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                )}
              </div>
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 13, color: '#475569' }}>หมายเหตุ</label>
              <textarea value={form.note} onChange={function (e) { setForm(Object.assign({}, form, { note: e.target.value })); }} rows={2} style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, boxSizing: 'border-box', fontFamily: 'inherit', resize: 'vertical' }} />
            </div>

            {error && <div style={{ background: '#fef2f2', color: '#dc2626', padding: 10, borderRadius: 8, fontSize: 13, marginBottom: 12 }}>⚠️ {error}</div>}

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={resetForm} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #e2e8f0', background: 'white', cursor: 'pointer', fontSize: 14 }}>ยกเลิก</button>
              <button onClick={handleSave} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: saving ? '#94a3b8' : '#10b981', color: 'white', cursor: saving ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 600 }}>{saving ? 'กำลังบันทึก...' : 'บันทึก'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
